import { render, staticRenderFns } from "./PhotoJoystick.vue?vue&type=template&id=afce7d06"
import script from "./PhotoJoystick.vue?vue&type=script&lang=js"
export * from "./PhotoJoystick.vue?vue&type=script&lang=js"
import style0 from "./PhotoJoystick.vue?vue&type=style&index=0&id=afce7d06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports